import { useCallback, useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { TransmissionFormType } from '.';
import en from '../../../lang/en-us';
import { SubmitButton } from '../../../lib/Button';
import { OtpField, ResendOtp, useTimer } from '../../../lib/OtpField';
import { onResendLoginOTP as resendOtp, verifyOtp } from '../../../redux-store/actions/login';
import { maskEmail } from '../../../utils/utilityFunctions';
import { sendEmailOTP } from '../../../redux-store/actions/nct';
import { LOGIN_RESEND_OTP, OTP_RESPONSE, VerifyOtpPayload } from '../../../redux-store/types/login';
import { PRE_LOGIN_TRANSMISSION } from '../../../redux-store/types/links';
import { ActionHeader } from '../../dashboard/makeNct';
const { dashboard } = en;

export interface StateProps extends TransmissionFormType {
    role: string;
}
interface TransmissionOTPProps extends RouteComponentProps<any, any, StateProps> {
    sendEmailOTP: (body: any) => Promise<any>;
    verifyOtp: (body: VerifyOtpPayload) => Promise<any>;
    resendOtp: (body: LOGIN_RESEND_OTP) => Promise<any>;
}

function TransmissionRequestOtpEmail(props: TransmissionOTPProps) {
    const [otpInput, setOtpInput] = useState<string[]>(new Array(6).fill(''));
    const otpRefInfo = useRef<OTP_RESPONSE | null>(null);
    const { startTimer, resetTimer, timer, stopTimer } = useTimer({});
    const { mobile, pan, email } = props.location.state || {};

    // console.log('otp-email', props);

    useEffect(() => {
        if (!props.location.state || !pan || !email) {
            return props.history.replace('/');
        }
        sendOtp();
    }, []);

    const sendOtp = useCallback(() => {
        async function callApi() {
            try {
                let { body = {} } = await props.sendEmailOTP({
                    email,
                    pan,
                    mobile: ``,
                    pekrn: '',
                    action: PRE_LOGIN_TRANSMISSION,
                });
                otpRefInfo.current = body;
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
    }, [email]);

    const onVerifyOtp = async () => {
        stopTimer();
        let payload: VerifyOtpPayload = {
            enteredOtp: otpInput.join(''),
            otpRef: otpRefInfo.current?.otpRef || '',
            reqId: otpRefInfo.current?.reqId || '',
            action: PRE_LOGIN_TRANSMISSION,
        };
        try {
            await props.verifyOtp(payload);
            props.history.replace('/links/transmission-request-pan', props.location.state);
        } catch (err: any) {
            alert(err.message);
            setOtpInput(new Array(6).fill(''));
        }
    };

    const onResend = async () => {
        try {
            let { body = {} } = await props.resendOtp({
                otpRef: otpRefInfo.current?.otpRef || '',
                reqId: otpRefInfo.current?.reqId || '',
                action: 'PRELOGIN_TRANSMISSION',
            });
            otpRefInfo.current = body;
            resetTimer();
        } catch (err: any) {
            return err.message;
        }
    };
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.TransmissionRequest.TransmissionUnitHeading} />
            {/* <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dashboard.TransmissionRequest.TransmissionRequestHeading}
            </h2> */}
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="icon" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.TransmissionRequest.otp.heading}
                            <span>{dashboard.TransmissionRequest.otp.email.headingSpan}</span>
                        </h3>
                        <p>
                            {dashboard.OtpScreen.subHeadingInfo}{' '}
                            {/* <span>{`*****@${email.split('@')[1]}`}</span> */}
                            <span>{maskEmail(email)}</span>
                        </p>
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setOtpInput(otp);
                            }}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            onClick={onVerifyOtp}
                            label={dashboard.OtpScreen.buttonText}
                            className="customBtn"
                            disabled={otpInput.join('').length !== 6}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, { sendEmailOTP, verifyOtp, resendOtp })(TransmissionRequestOtpEmail);
